import { useEffect, useState } from 'react';
import type { FC } from 'react';
import { getShipToForNewOrders, type Customer } from '../../types/customer';
import { useParams } from 'react-router-dom';
import api from '../../api/Api';
import ItemDetail from '../../components/dashboard/overview/ItemDetail';
import useCustomer from '../../hooks/useCustomer';
import { Item } from 'src/types/itemList';
import PageContainerLayout from 'src/pages/PageContainerLayout';
import CustomerPrice from 'src/components/controls/CustomerPrice';

const ItemDetailPage: FC<React.PropsWithChildren<unknown>> = () => {
  const { customerNumber: customerNumberParam, itemNumber: itemNumberParam } = useParams();

  const { saveCustomer, customer } = useCustomer();
  const [data, setData] = useState<Item>(undefined);

  const init = async () => {
    let cust = await api.get<Customer>(`/customer/${customerNumberParam}`);
    saveCustomer(cust);
    let item = await api.get<Item>(`/Item/getbyitemnumber?itemNumber=${encodeURIComponent(itemNumberParam)}`);
    setData(item);
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <PageContainerLayout pageHeaderTitle="Item Details">
      {data && (
        <div>
          <div className="item-detail-header">
            {data.images && data.images.length > 0 && (
              <img
                className="item-detail-header__img"
                src={`https://www.bfgsupply.com/img/product/thumb/${data.images[0]}`}
                onError={({ currentTarget }) => {
                  currentTarget.src = 'https://www.bfgsupply.com/content/img/img_not_avail.png';
                }}
              />
            )}
            <div className="item-detail-header__content">
              <h1>{data.itemNumber}</h1>
              <h2>{data.name}</h2>
              <p className="stock-deff">{data.stockDefinition}</p>
              <CustomerPrice
                customerNumber={customer.number.toString()}
                itemNumber={data.itemNumber}
                quantity={1}
                warehouseCode={customer.warehouseCode}
                defaultPrice={data.listPrice}
                load={true}
                shipToNumber={getShipToForNewOrders(customer)}
              ></CustomerPrice>
            </div>
          </div>
          <ItemDetail dataItem={data} dataIndex={0} />
        </div>
      )}
    </PageContainerLayout>
  );
};

export default ItemDetailPage;
